import { TabSelectionPoolsNInfoEnum } from "../../../types";

export const tabListHeader = {
  [TabSelectionPoolsNInfoEnum.INFO_CHANGES]: "Info & Changes",
  [TabSelectionPoolsNInfoEnum.PROBABLES]: "Probables",
  [TabSelectionPoolsNInfoEnum.POOLS]: "Pools",
  [TabSelectionPoolsNInfoEnum.WILL_PAYS]: "Will Pays"
};
